import { render, staticRenderFns } from "./face-alarm.vue?vue&type=template&id=43e9eb20&scoped=true&"
import script from "./face-alarm.vue?vue&type=script&lang=ts&"
export * from "./face-alarm.vue?vue&type=script&lang=ts&"
import style0 from "./face-alarm.vue?vue&type=style&index=0&id=43e9eb20&prod&scoped=true&lang=scss&"
import style1 from "./face-alarm.vue?vue&type=style&index=1&id=43e9eb20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e9eb20",
  null
  
)

export default component.exports